import { useContext } from "react";
import { Form, Input, Select } from "antd";
import { getFormQuestions } from "../parser";
import { Context } from "../EditorContext";

export default () => {
  const { shareRefs, editorOptions } = useContext(Context);
  const { formIdOptions } = editorOptions;
  return (
    <Form.Item
      label="Field name"
      name="id"
      rules={[
        { required: true },
        {
          validator(_, value) {
            const questions = getFormQuestions(shareRefs.tree);
            const otherQuestions = questions.filter(
              (q) => q.prop_key !== shareRefs.selectedNode.id,
            );
            const foundKey = otherQuestions.find((q) => q.prop_key === value);
            if (foundKey) {
              return Promise.reject(
                new Error("Other questions have already used this value, please select another one.")
              );
            }
            return Promise.resolve();
          },
        },
      ]}
    >
      {
        Array.isArray(formIdOptions)
          ? <Select options={formIdOptions} />
          : <Input maxLength={100} />
       }
    </Form.Item>
  );
};
